const { HTMLElementExt } = await import(
    window._resolveImport?.("html-element-ext") || "html-element-ext"
);

class DetailsDisclosure extends HTMLElementExt {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");

        this.handles = {
            keyup: this.onKeyUp.bind(this),
            "focusout::details": this.onFocusOut.bind(this),
        };
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        const openDetailsElement = event.target.closest("details[open]");
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector("summary");
        openDetailsElement.removeAttribute("open");
        summaryElement.focus();
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    close() {
        this.mainDetailsToggle.removeAttribute("open");
    }
}

export { DetailsDisclosure };
